/* Environment detector — distinguishes the Emergent preview environment
   from the production deployment based on the runtime hostname. Preview
   URLs live under `*.preview.emergentagent.com`; the production custom
   domain (or the bare Emergent-provided prod URL) does not contain
   `.preview.`. Anything else (localhost, staging) counts as preview so
   developers keep full access while building.

   Rule of thumb: use `isProduction()` to gate features that should be
   HIDDEN or REDIRECTED-TO-WAITLIST on the live production site while
   staying fully clickable in preview + local dev. */

export function isPreviewEnv() {
  if (typeof window === "undefined") return true;  // SSR default = allow
  const h = (window.location && window.location.hostname) || "";
  // Standard Emergent preview subdomain, plus local dev.
  return (
    h.includes(".preview.emergentagent.com")
    || h === "localhost"
    || h === "127.0.0.1"
    || h.endsWith(".local")
  );
}

export function isProduction() {
  return !isPreviewEnv();
}
